<template>
    <div>
        <top-stick-bar/>
        <top-second-bar/>
    </div>
</template>

<script>
import TopStickBar from '@/components/ThemeCosmic/pages/partialsCommon/TopStickBar';
import TopSecondBar from '@/components/ThemeCosmic/home/partials/TopSecondBar';
export default {
    name: 'PagesHeader',
	components:{
        TopStickBar,
        TopSecondBar
    }
};
</script>